export const OPERACAO_HISTORICO = [
  {
    "data": "10052019",
    "hora": "54426",
    "origem": "DECLARACAO IRPF",
    "operacao": "ALTER. DE END",
    "numeroDocumento": "25946762",
    "dataDocumento": "30042019",
    "terminalUsuario": "",
    "cpfUsuario": "0",
    "localTrabalhoUsuario": "0",
    "situacaoAnterior": {
      "codigo": 0,
      "descricao": "REGULAR"
    },
    "situacaoPosterior": {
      "codigo": 0,
      "descricao": "REGULAR"
    },
    "nomeAnterior": "XVORMZ NLIVML UVIRZMR",
    "nomePosterior": "XVORMZ NLIVML UVIRZMR",
    "dataNascimentoAnterior": "29071970",
    "dataNascimentoPosterior": "29071970",
    "tituloEleitorAnterior": "109153240132",
    "tituloEleitorPosterior": "109153240132",
    "naturalidadeAnterior": {
      "codigo": 7107,
      "nome": "SAO PAULO",
      "uf": "SP"
    },
    "naturalidadePosterior": {
      "codigo": 7107,
      "nome": "SAO PAULO",
      "uf": "SP"
    },
    "nomeMaeAnterior": "ZOARIZ NZIRM",
    "nomeMaePosterior": "ZOARIZ NZIRM",
    "enderecoAnterior": {
      "logradouro": "R DR ANTONIO DUARTE DA CONCEICAO",
      "numeroLogradouro": "1700",
      "complemento": "CASA 23",
      "bairro": "PQ ANHUMAS",
      "municipio": {
        "codigo": 6291,
        "nome": "CAMPINAS",
        "uf": "SP"
      },
      "cep": 13091241
    },
    "enderecoPosterior": {
      "logradouro": "I WI ZMGLMRL WFZIGV WZ XLMXVRXZL",
      "numeroLogradouro": "1700",
      "complemento": "CASA 23",
      "bairro": "PQ ANHUMAS",
      "municipio": {
        "codigo": 6291,
        "nome": "CAMPINAS",
        "uf": "SP"
      },
      "cep": 13091606
    },
    "uaAnterior": {
      "codigo": 810400,
      "nome": "CAMPINAS"
    },
    "uaPosterior": {
      "codigo": 818100,
      "nome": "CAMPINAS"
    },
    "indResidenteExteriorAnterior": "Não",
    "indResidenteExteriorPosterior": "Não",
    "descricao": ""
  },
  {
    "data": "14052012",
    "hora": "53146",
    "origem": "DECLARACAO IRPF",
    "operacao": "ALTER. DE END",
    "numeroDocumento": "21930439",
    "dataDocumento": "30042012",
    "terminalUsuario": "",
    "cpfUsuario": "0",
    "localTrabalhoUsuario": "0",
    "situacaoAnterior": {
      "codigo": 0,
      "descricao": "REGULAR"
    },
    "situacaoPosterior": {
      "codigo": 0,
      "descricao": "REGULAR"
    },
    "nomeAnterior": "XVORMZ NLIVML UVIRZMR",
    "nomePosterior": "XVORMZ NLIVML UVIRZMR",
    "dataNascimentoAnterior": "29071970",
    "dataNascimentoPosterior": "29071970",
    "tituloEleitorAnterior": "109153240132",
    "tituloEleitorPosterior": "109153240132",
    "naturalidadeAnterior": {
      "codigo": 7107,
      "nome": "SAO PAULO",
      "uf": "SP"
    },
    "naturalidadePosterior": {
      "codigo": 7107,
      "nome": "SAO PAULO",
      "uf": "SP"
    },
    "nomeMaeAnterior": "ZOARIZ NZIRM",
    "nomeMaePosterior": "ZOARIZ NZIRM",
    "enderecoAnterior": {
      "logradouro": "DR ANTONIO DUARTE DA CONCEICAO",
      "numeroLogradouro": "1700",
      "complemento": "CASA 23",
      "bairro": "JD MADALENA",
      "municipio": {
        "codigo": 6291,
        "nome": "CAMPINAS",
        "uf": "SP"
      },
      "cep": 13091606
    },
    "enderecoPosterior": {
      "logradouro": "R DR ANTONIO DUARTE DA CONCEICAO",
      "numeroLogradouro": "1700",
      "complemento": "CASA 23",
      "bairro": "PQ ANHUMAS",
      "municipio": {
        "codigo": 6291,
        "nome": "CAMPINAS",
        "uf": "SP"
      },
      "cep": 13091241
    },
    "uaAnterior": {
      "codigo": 810400,
      "nome": "CAMPINAS"
    },
    "uaPosterior": {
      "codigo": 810400,
      "nome": "CAMPINAS"
    },
    "indResidenteExteriorAnterior": "Não",
    "indResidenteExteriorPosterior": "Não",
    "descricao": ""
  },
  {
    "data": "30032011",
    "hora": "153014",
    "origem": "ECT/HOD",
    "operacao": "ALTER. DE END NASC NAT TEL",
    "numeroDocumento": "1",
    "dataDocumento": "30032011",
    "terminalUsuario": "KWTE5175",
    "cpfUsuario": "94971129804",
    "localTrabalhoUsuario": "8104",
    "situacaoAnterior": {
      "codigo": 0,
      "descricao": "REGULAR"
    },
    "situacaoPosterior": {
      "codigo": 0,
      "descricao": "REGULAR"
    },
    "nomeAnterior": "XVORMZ NLIVML UVIRZMR",
    "nomePosterior": "XVORMZ NLIVML UVIRZMR",
    "dataNascimentoAnterior": "14031950",
    "dataNascimentoPosterior": "29071970",
    "tituloEleitorAnterior": "109153240132",
    "tituloEleitorPosterior": "109153240132",
    "naturalidadeAnterior": {
      "codigo": 0,
      "nome": "",
      "uf": ""
    },
    "naturalidadePosterior": {
      "codigo": 7107,
      "nome": "SAO PAULO",
      "uf": "SP"
    },
    "nomeMaeAnterior": "ZOARIZ NZIRM",
    "nomeMaePosterior": "ZOARIZ NZIRM",
    "enderecoAnterior": {
      "logradouro": "R DOUTOR ANTONIO DUARTE DA CONCEICAO",
      "numeroLogradouro": "1700",
      "complemento": "CASA",
      "bairro": "JD. MADALENA",
      "municipio": {
        "codigo": 6291,
        "nome": "CAMPINAS",
        "uf": "SP"
      },
      "cep": 13091241
    },
    "enderecoPosterior": {
      "logradouro": "DR ANTONIO DUARTE DA CONCEICAO",
      "numeroLogradouro": "1700",
      "complemento": "CASA 23",
      "bairro": "JD MADALENA",
      "municipio": {
        "codigo": 6291,
        "nome": "CAMPINAS",
        "uf": "SP"
      },
      "cep": 13091606
    },
    "uaAnterior": {
      "codigo": 810400,
      "nome": "CAMPINAS"
    },
    "uaPosterior": {
      "codigo": 810400,
      "nome": "CAMPINAS"
    },
    "indResidenteExteriorAnterior": "Não",
    "indResidenteExteriorPosterior": "Não",
    "descricao": "CA= 601199995"
  },
  {
    "data": "4052008",
    "hora": "205210",
    "origem": "DECLARACAO IRPF",
    "operacao": "ALTER. DE END",
    "numeroDocumento": "264489",
    "dataDocumento": "18042008",
    "terminalUsuario": "",
    "cpfUsuario": "0",
    "localTrabalhoUsuario": "0",
    "situacaoAnterior": {
      "codigo": 0,
      "descricao": "NAO DISPONIVEL"
    },
    "situacaoPosterior": {
      "codigo": 0,
      "descricao": "NAO DISPONIVEL"
    },
    "nomeAnterior": "XVORMZ NLIVML UVIRZMR",
    "nomePosterior": "XVORMZ NLIVML UVIRZMR",
    "dataNascimentoAnterior": "14031950",
    "dataNascimentoPosterior": "14031950",
    "tituloEleitorAnterior": "109153240132",
    "tituloEleitorPosterior": "109153240132",
    "naturalidadeAnterior": {
      "codigo": 0,
      "nome": "",
      "uf": ""
    },
    "naturalidadePosterior": {
      "codigo": 0,
      "nome": "",
      "uf": ""
    },
    "nomeMaeAnterior": "ZOARIZ NZIRM",
    "nomeMaePosterior": "ZOARIZ NZIRM",
    "enderecoAnterior": {
      "logradouro": "R DOUTOR ANTONIO DUARTE DA CONCEICAO",
      "numeroLogradouro": "1700",
      "complemento": "CASA",
      "bairro": "JD. MADALENA",
      "municipio": {
        "codigo": 6291,
        "nome": "CAMPINAS",
        "uf": "SP"
      },
      "cep": 13000000
    },
    "enderecoPosterior": {
      "logradouro": "R DOUTOR ANTONIO DUARTE DA CONCEICAO",
      "numeroLogradouro": "1700",
      "complemento": "CASA",
      "bairro": "JD. MADALENA",
      "municipio": {
        "codigo": 6291,
        "nome": "CAMPINAS",
        "uf": "SP"
      },
      "cep": 13091241
    },
    "uaAnterior": {
      "codigo": 810400,
      "nome": "CAMPINAS"
    },
    "uaPosterior": {
      "codigo": 810400,
      "nome": "CAMPINAS"
    },
    "indResidenteExteriorAnterior": null,
    "indResidenteExteriorPosterior": null,
    "descricao": ""
  },
  {
    "data": "29062005",
    "hora": "20459",
    "origem": "DECLARACAO IRPF",
    "operacao": "ALTER. DE END",
    "numeroDocumento": "27338323",
    "dataDocumento": "27042005",
    "terminalUsuario": "",
    "cpfUsuario": "0",
    "localTrabalhoUsuario": "0",
    "situacaoAnterior": {
      "codigo": 0,
      "descricao": "NAO DISPONIVEL"
    },
    "situacaoPosterior": {
      "codigo": 0,
      "descricao": "NAO DISPONIVEL"
    },
    "nomeAnterior": "XVORMZ NLIVML UVIRZMR",
    "nomePosterior": "XVORMZ NLIVML UVIRZMR",
    "dataNascimentoAnterior": "14031950",
    "dataNascimentoPosterior": "14031950",
    "tituloEleitorAnterior": "109153240132",
    "tituloEleitorPosterior": "109153240132",
    "naturalidadeAnterior": {
      "codigo": 0,
      "nome": "",
      "uf": ""
    },
    "naturalidadePosterior": {
      "codigo": 0,
      "nome": "",
      "uf": ""
    },
    "nomeMaeAnterior": "ZOARIZ NZIRM",
    "nomeMaePosterior": "ZOARIZ NZIRM",
    "enderecoAnterior": {
      "logradouro": "RUA DR. ANTONIO DUARTE DA CONCEICAO",
      "numeroLogradouro": "1700",
      "complemento": "CASA 23",
      "bairro": "PARQUE ANHUMAS",
      "municipio": {
        "codigo": 6291,
        "nome": "CAMPINAS",
        "uf": "SP"
      },
      "cep": 13000000
    },
    "enderecoPosterior": {
      "logradouro": "R DOUTOR ANTONIO DUARTE DA CONCEICAO",
      "numeroLogradouro": "1700",
      "complemento": "CASA",
      "bairro": "JD. MADALENA",
      "municipio": {
        "codigo": 6291,
        "nome": "CAMPINAS",
        "uf": "SP"
      },
      "cep": 13000000
    },
    "uaAnterior": {
      "codigo": 0,
      "nome": "NAO DISPONIVEL"
    },
    "uaPosterior": {
      "codigo": 0,
      "nome": "NAO DISPONIVEL"
    },
    "indResidenteExteriorAnterior": null,
    "indResidenteExteriorPosterior": null,
    "descricao": ""
  },
  {
    "data": "16052004",
    "hora": "42926",
    "origem": "DECLARACAO IRPF",
    "operacao": "ALTER. DE END",
    "numeroDocumento": "27399046",
    "dataDocumento": "10052004",
    "terminalUsuario": "",
    "cpfUsuario": "0",
    "localTrabalhoUsuario": "0",
    "situacaoAnterior": {
      "codigo": 0,
      "descricao": "NAO DISPONIVEL"
    },
    "situacaoPosterior": {
      "codigo": 0,
      "descricao": "NAO DISPONIVEL"
    },
    "nomeAnterior": "XVORMZ NLIVML UVIRZMR",
    "nomePosterior": "XVORMZ NLIVML UVIRZMR",
    "dataNascimentoAnterior": "14031950",
    "dataNascimentoPosterior": "14031950",
    "tituloEleitorAnterior": "109153240132",
    "tituloEleitorPosterior": "109153240132",
    "naturalidadeAnterior": {
      "codigo": 0,
      "nome": "",
      "uf": ""
    },
    "naturalidadePosterior": {
      "codigo": 0,
      "nome": "",
      "uf": ""
    },
    "nomeMaeAnterior": "ZOARIZ NZIRM",
    "nomeMaePosterior": "ZOARIZ NZIRM",
    "enderecoAnterior": {
      "logradouro": "R FRANCISCO P COUTINHO",
      "numeroLogradouro": "111",
      "complemento": "APTO 1204",
      "bairro": "PRQ TAQUARAL",
      "municipio": {
        "codigo": 6291,
        "nome": "CAMPINAS",
        "uf": "SP"
      },
      "cep": 13088100
    },
    "enderecoPosterior": {
      "logradouro": "RUA DR. ANTONIO DUARTE DA CONCEICAO",
      "numeroLogradouro": "1700",
      "complemento": "CASA 23",
      "bairro": "PARQUE ANHUMAS",
      "municipio": {
        "codigo": 6291,
        "nome": "CAMPINAS",
        "uf": "SP"
      },
      "cep": 13000000
    },
    "uaAnterior": {
      "codigo": 0,
      "nome": "NAO DISPONIVEL"
    },
    "uaPosterior": {
      "codigo": 0,
      "nome": "NAO DISPONIVEL"
    },
    "indResidenteExteriorAnterior": null,
    "indResidenteExteriorPosterior": null,
    "descricao": ""
  },
  {
    "data": "30111996",
    "hora": "225439",
    "origem": "RECADASTRAMENTO",
    "operacao": "ALTER. DE END NOME",
    "numeroDocumento": "6579854",
    "dataDocumento": "31101996",
    "terminalUsuario": "",
    "cpfUsuario": "0",
    "localTrabalhoUsuario": "0",
    "situacaoAnterior": {
      "codigo": 0,
      "descricao": "NAO DISPONIVEL"
    },
    "situacaoPosterior": {
      "codigo": 0,
      "descricao": "NAO DISPONIVEL"
    },
    "nomeAnterior": "XVORMZ NLIVML",
    "nomePosterior": "XVORMZ NLIVML UVIRZMR",
    "dataNascimentoAnterior": "14031950",
    "dataNascimentoPosterior": "14031950",
    "tituloEleitorAnterior": "109153240132",
    "tituloEleitorPosterior": "109153240132",
    "naturalidadeAnterior": {
      "codigo": 0,
      "nome": "",
      "uf": ""
    },
    "naturalidadePosterior": {
      "codigo": 0,
      "nome": "",
      "uf": ""
    },
    "nomeMaeAnterior": "ZOARIZ NZIRM",
    "nomeMaePosterior": "ZOARIZ NZIRM",
    "enderecoAnterior": {
      "logradouro": "NAO DISPONIVEL",
      "numeroLogradouro": "",
      "complemento": "",
      "bairro": "",
      "municipio": {
        "codigo": 6291,
        "nome": "",
        "uf": ""
      },
      "cep": 0
    },
    "enderecoPosterior": {
      "logradouro": "R FRANCISCO P COUTINHO",
      "numeroLogradouro": "111",
      "complemento": "APTO 1204",
      "bairro": "PRQ TAQUARAL",
      "municipio": {
        "codigo": 6291,
        "nome": "CAMPINAS",
        "uf": "SP"
      },
      "cep": 13088100
    },
    "uaAnterior": {
      "codigo": 0,
      "nome": "NAO DISPONIVEL"
    },
    "uaPosterior": {
      "codigo": 0,
      "nome": "NAO DISPONIVEL"
    },
    "indResidenteExteriorAnterior": null,
    "indResidenteExteriorPosterior": null,
    "descricao": ""
  },
  {
    "data": "24041993",
    "hora": "0",
    "origem": "PIS",
    "operacao": "ALTER. DE MAE",
    "numeroDocumento": "172031",
    "dataDocumento": "24041993",
    "terminalUsuario": "",
    "cpfUsuario": "0",
    "localTrabalhoUsuario": "0",
    "situacaoAnterior": {
      "codigo": 0,
      "descricao": "NAO DISPONIVEL"
    },
    "situacaoPosterior": {
      "codigo": 0,
      "descricao": "NAO DISPONIVEL"
    },
    "nomeAnterior": "XVORMZ NLIVML",
    "nomePosterior": "XVORMZ NLIVML",
    "dataNascimentoAnterior": "14031950",
    "dataNascimentoPosterior": "14031950",
    "tituloEleitorAnterior": "109153240132",
    "tituloEleitorPosterior": "109153240132",
    "naturalidadeAnterior": {
      "codigo": 0,
      "nome": "",
      "uf": ""
    },
    "naturalidadePosterior": {
      "codigo": 0,
      "nome": "",
      "uf": ""
    },
    "nomeMaeAnterior": "",
    "nomeMaePosterior": "ZOARIZ NZIRM",
    "enderecoAnterior": {
      "logradouro": "NAO DISPONIVEL",
      "numeroLogradouro": "",
      "complemento": "",
      "bairro": "",
      "municipio": {
        "codigo": 6291,
        "nome": "",
        "uf": ""
      },
      "cep": 0
    },
    "enderecoPosterior": {
      "logradouro": "NAO DISPONIVEL",
      "numeroLogradouro": "",
      "complemento": "",
      "bairro": "",
      "municipio": {
        "codigo": 6291,
        "nome": "",
        "uf": ""
      },
      "cep": 0
    },
    "uaAnterior": {
      "codigo": 0,
      "nome": "NAO DISPONIVEL"
    },
    "uaPosterior": {
      "codigo": 0,
      "nome": "NAO DISPONIVEL"
    },
    "indResidenteExteriorAnterior": null,
    "indResidenteExteriorPosterior": null,
    "descricao": ""
  }
];
